(function () {
  /**
   * @awaitingdeprecation
   */
  angular.module('binky.core.authentication.ready').constant('AUTHENTICATION_READY_ERROR', {
    REQUIRED_ROLES_NOT_FOUND: 'Required roles not found',
    USER_SIGNED_OUT: 'User signed out!',
  });
})();
